var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelemovel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "20px",
    viewBox: "0 0 14 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "telem") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Pesquisa",
    transform: "translate(-592.000000, -6114.000000)",
    stroke: "",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21-Copy-2",
    transform: "translate(162.000000, 5902.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "telem",
    transform: "translate(431.000000, 213.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.51949211,7.33775821 C6.51949211,6.96796478 6.2271105,6.40514731 5.79059712,5.94392144 C5.39320522,5.51926854 4.86403569,5.18807992 4.34310226,5.18807992",
    id: "Stroke-1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.69732327,7.33775821 C8.69732327,4.96254656 6.75154427,3.04043346 4.34454358,3.04043346",
    id: "Stroke-3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12560055,18 L2.87234043,18 C1.28483185,18 0,16.730105 0,15.1655943 L0,2.83440569 C0,1.26786319 1.28483185,0 2.87234043,0 L9.12560055,0 C10.7131091,0 12,1.26786319 12,2.83440569 L12,15.1655943 C12,16.730105 10.7131091,18 9.12560055,18 Z",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.55573095,
    y1: 14.922384,
    x2: 8.44179822,
    y2: 14.922384,
    id: "Stroke-7",
    strokeLinecap: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelemovel);
export default __webpack_public_path__ + "static/media/telemovel.68676a9a7c3b0599d7ba4874091265b8.svg";
export { ForwardRef as ReactComponent };